import { OutsourceState } from '../../../../shared/model/OutsourceState';

export class CompaniesExportRequest {
    _page; // number
    _term; // string
    _state; // number

    constructor() {
        this._page = 1;
        this._term = '';
        this._state = OutsourceState.ALL;
    }

    setPage(page) {
        this._page = page;
    }

    setTerm(term) {
        this._term = term;
    }

    setState(state) {
        this._state = state;
    }

    body() {
        let criteria = {
            term: this._term,
            page: this._page,
            show_only_deleted: false,
        };
        if (this._state === OutsourceState.ACTIVE) {
            criteria = {
                ...criteria,
                only_active: true,
            }
        }
        if (this._state === OutsourceState.INACTIVE) { // 1
            criteria = {
                ...criteria,
                only_inactive: true,
            }
        }

        return {
            criteria: criteria,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/outsource/list/companies-export/CompaniesExportRequest.js